<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-finance-body">
            <div class="dw-stat-grid">
                <div class="dw-stat-item" v-for="(item, i) in periods" :key="item.label">
                    <span class="dw-stat-label">{{ item.label }}</span>
                    <span class="dw-stat-value" :style="{ color: colors[i] }">{{ item.value }}</span>
                </div>
            </div>
            <div class="dw-sparkline-wrap">
                <apexchart type="area" height="90" :options="chartOpts" :series="chartSeries" />
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';
import { sparklineOpts, cssVar } from '../chartOpts';

export const meta = {
    id: 'expenses',
    titleKey: 'common.dashboard.widgetTitles.expenses',
    icon: 'bi-graph-down-arrow',
    accent: 'var(--bs-danger)',
    accentBg: 'rgba(var(--bs-danger-rgb, 241, 65, 108), 0.12)',
    glassRgb: '241, 65, 108',
    defaultCol: 1,
    defaultRow: 1,
    source: { type: 'statistics', key: 'expenses' },
};

function fmtTRY(n) {
    return (parseFloat(n) || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 });
}

export default {
    name: 'ExpensesWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        periods() {
            const d = this.apiData || {};
            return [
                { label: this.$t('common.dashboard.widgetLabels.periodToday'), value: fmtTRY(d.today) },
                { label: this.$t('common.dashboard.widgetLabels.periodWeek'), value: fmtTRY(d.this_week) },
                { label: this.$t('common.dashboard.widgetLabels.periodMonth'), value: fmtTRY(d.this_month) },
                { label: this.$t('common.dashboard.widgetLabels.periodTotal'), value: fmtTRY(d.total) },
            ];
        },
        sparkline() {
            const dt = this.apiData?.daily_totals;
            if (!dt) return [];
            return Object.values(dt).map(v => parseFloat(v) || 0);
        },
        colors() {
            return [
                cssVar('--bs-danger', '#F1416C'),
                cssVar('--bs-warning', '#FFC700'),
                cssVar('--bs-info', '#7239EA'),
                cssVar('--bs-gray-600', '#7E8299'),
            ];
        },
        chartOpts() { return sparklineOpts(cssVar('--bs-danger', '#F1416C')); },
        chartSeries() { return [{ data: this.sparkline }]; },
    },
};
</script>
